<template>
  <div>
    <v-dialog
      v-model="open"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title text-xs-center">
            <i v-if="type === 'info'" class="material-icons icon">info</i>
            <i v-else-if="type === 'warning'" class="material-icons icon">warning</i>
            <i v-else class="material-icons icon">error</i>
          </div>

          <luci-btn-icon :config="exitBtnConfig" @callback="$emit('ok-callback')" class="exit-btn"></luci-btn-icon>
        </v-card-title>

        <v-card-text class="text-xs-center">
          <h3 v-html="title" class="luci-subtitle"></h3>
          <p v-html="message" class="luci-text"></p>

          <template v-if="type === 'error' && details">
            <v-divider></v-divider>
            <luci-link :config="detailsLinkConfig" @callback="toggleDetails"></luci-link>
            <p v-if="showDetails" class="details luci-text">{{ details }}</p>
          </template>

        </v-card-text>

        <v-card-actions>
         <div class="actions text-xs-center">
           <div class="action-btn">
             <luci-btn-icon :config="okBtnConfig" @callback="$emit('ok-callback')"></luci-btn-icon>
             <div class="ok-btn-text">{{ okText }}</div>
           </div>
         </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import variables from '../../helpers/variables'

export default {
  name: 'MessageModal',
  props: {
    item: { type: Object, default: null },
    open: { type: Boolean, default: false },
    /* type: error | warning | info */
    type: { type: String, default: 'error' },
    title: { type: String, default: 'An error occurred' },
    message: { type: String, default: 'Something went wrong, please try again or contact PM Connect for support.' },
    details: { type: String, default: null },
    okText: { type: String, default: 'OK' }
  },
  computed: {
    okBtnConfig () {
      return (
        {
          type: 'button',
          name: 'ok-btn',
          primary: true,
          icon: true,
          iconType: 'thumb_up',
          tooltip: this.okText
        }
      )
    },
    detailsLinkConfig () {
      return (
        {
          linkText: this.detailsLinkText,
          underline: true,
          linkAction: true
        }
      )
    }
  },
  data () {
    return {
      detailsLinkText: 'Show details',
      showDetails: false,
      exitBtnConfig: variables.exitBtnIconConfigOptions
    }
  },
  methods: {
    toggleDetails () {
      this.showDetails = !this.showDetails
      this.showDetails ? this.detailsLinkText = 'Hide details' : this.detailsLinkText = 'Show details'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/modal';

  @include modal;
</style>
